import * as css from 'css/exports.module.scss';
import './JiraIssue.scss';
import { createAsyncSelectors } from '@lib/selectors';
import flatMap from 'lodash/flatMap';
import { JiraIssueMappingTooltip } from './JiraIssueMappingTooltip';
import { JiraIssuesOptions } from './JiraIssueOptions';
import { jiraSummarySelectors } from '../../../settings/jira/@arch/selectors';
import { SonarText } from '@ui/text';
import { Case, Default, Switch, When } from 'react-if';
import { CloseCircleOutlined, ExclamationCircleOutlined, MoreOutlined, SyncOutlined } from '@ant-design/icons';
import { Popover, Row, Tag, Tooltip } from 'antd';
import React, { useMemo, useState } from 'react';
import { useCurrentUser, useJiraStatuses, useSonarSelector } from '@hooks';
export const jiraSyncSelector = createAsyncSelectors((state) => state.integrations.jira.initiatives.sync.post);
export const JiraIssue = ({ initiativeId, issueKey, issueName, isSynced, projectKey, statusId, summary }) => {
    var _a;
    const [open, setOpen] = useState(false);
    const jiraStatuses = useJiraStatuses();
    const { isReadOnly } = useCurrentUser();
    const issueStatus = (_a = jiraStatuses.filter((status) => status.id === statusId)) === null || _a === void 0 ? void 0 : _a[0];
    const isRequested = useSonarSelector(jiraSyncSelector.isRequested);
    const jiraSummary = useSonarSelector(jiraSummarySelectors.data);
    const allStatuses = useMemo(() => {
        var _a, _b;
        return flatMap((_b = (_a = jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.selectedProjects.filter((project) => project.projectKey === projectKey)[0]) === null || _a === void 0 ? void 0 : _a.issueTypes.map(({ statuses }) => statuses)) !== null && _b !== void 0 ? _b : []);
    }, [jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.selectedProjects, projectKey]);
    const jiraIssueURL = useMemo(() => `${jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.url}browse/${issueKey}`, [issueKey, jiraSummary]);
    const { incompleteMapping, missingMapping } = useMemo(() => ({
        incompleteMapping: allStatuses.some((statusMap) => !statusMap.initiativeStatusId),
        missingMapping: allStatuses.some((statusMap) => statusMap.jiraStatusId === (issueStatus === null || issueStatus === void 0 ? void 0 : issueStatus.id) && !statusMap.initiativeStatusId)
    }), [allStatuses, issueStatus === null || issueStatus === void 0 ? void 0 : issueStatus.id]);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const hide = () => {
        setOpen(false);
    };
    return (React.createElement(Row, { gutter: Number(css.size32), id: 'jira-issue', wrap: false },
        React.createElement("div", { className: 'jira-label' },
            React.createElement("a", { className: 'issue-key', href: jiraIssueURL, target: '_blank' }, issueKey),
            React.createElement(When, { condition: jiraStatuses.length },
                React.createElement(Tag, null, issueStatus === null || issueStatus === void 0 ? void 0 : issueStatus.name)),
            React.createElement(SonarText, { className: 'issue-name' }, issueName)),
        React.createElement(When, { condition: summary },
            React.createElement(Switch, null,
                React.createElement(Case, { condition: isSynced && (jiraStatuses.length === 0 || isRequested) },
                    React.createElement(Tooltip, { placement: 'bottom', title: 'Loading' },
                        React.createElement(SyncOutlined, { className: 'sync-icon loading' }))),
                React.createElement(Case, { condition: isSynced && missingMapping },
                    React.createElement(Tooltip, { placement: 'bottom', title: React.createElement(JiraIssueMappingTooltip, { missingMapping: true }) },
                        React.createElement(CloseCircleOutlined, { className: 'sync-icon missing' }))),
                React.createElement(Case, { condition: isSynced && incompleteMapping },
                    React.createElement(Tooltip, { title: React.createElement(JiraIssueMappingTooltip, null) },
                        React.createElement(ExclamationCircleOutlined, { className: 'sync-icon incomplete' }))),
                React.createElement(Case, { condition: isSynced },
                    React.createElement(SyncOutlined, { className: 'sync-icon' })),
                React.createElement(Default, null)),
            React.createElement(When, { condition: !isReadOnly },
                React.createElement(Popover, { content: React.createElement(JiraIssuesOptions, { hide: hide, initiativeId: initiativeId, issueKey: issueKey, isSynced: isSynced }), onOpenChange: handleOpenChange, open: open, overlayClassName: 'issue-options', placement: 'bottomRight', trigger: 'click' },
                    React.createElement(MoreOutlined, { className: 'issue-more' }))))));
};
